import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-col-6" }
const _hoisted_2 = { class: "p-col-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_info_button = _resolveComponent("info-button")!
  const _component_Button = _resolveComponent("Button")!
  const _component_category_picker = _resolveComponent("category-picker")!
  const _component_string_picker = _resolveComponent("string-picker")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.specimen, (item, key) => {
    return (_openBlock(), _createElementBlock("div", {
      key: key,
      class: "p-d-flex p-flex-column p-flex-md-row"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives((_openBlock(), _createBlock(_component_Button, {
          class: _normalizeClass(["tooltipButton formBox", { required: item.required, notRequired: !item.required }])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_info_button),
            _createTextVNode(" " + _toDisplayString(_ctx.$t(item.title)), 1)
          ]),
          _: 2
        }, 1032, ["class"])), [
          [
            _directive_tooltip,
            _ctx.$t(item.help),
            void 0,
            { right: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_2, [
        (item.component === _ctx.ComponentEnum.CategoryPicker)
          ? (_openBlock(), _createBlock(_component_category_picker, {
              key: 0,
              name: item.name,
              api: item.api,
              value: item.value == null ? item.defaultValue : item.value,
              filter: item.filter,
              clearable: item.clearable,
              onSelect: _ctx.select
            }, null, 8, ["name", "api", "value", "filter", "clearable", "onSelect"]))
          : (_openBlock(), _createBlock(_component_string_picker, {
              key: 1,
              onSelect: _ctx.select,
              value: item.value,
              name: item.name,
              placeholder: _ctx.$t(item.placeholder)
            }, null, 8, ["onSelect", "value", "name", "placeholder"]))
      ])
    ]))
  }), 128))
}